// Module
var code = "<react-code-editor\r\n  id=\"$ctrl.identifier\"\r\n  text-tip=\"$ctrl.textTip\"\r\n  type=\"$ctrl.type\"\r\n  readonly=\"$ctrl.readOnly\"\r\n  on-change=\"($ctrl.handleChange)\"\r\n  value=\"$ctrl.value\"\r\n  height=\"$ctrl.height || undefined\"\r\n  schema=\"$ctrl.schema\"\r\n></react-code-editor>\r\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/components/code-editor/code-editor.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;